import * as React from 'react'
import { Alert, Form, Select } from 'antd'
import { NotificationNativeAndroidContentModel } from '../../../models/notification/notification-native-android-content.model'
import { getClassNames } from '../../../_utils/classnames'
import { DomainDto } from '../../../dtos/domain'
import { INotificationBuilderState } from '../interfaces/notification-builder-state.interface'
import { DeliveryChannel } from '@pushly/aqe/lib/enums/delivery-channels'

interface INotificationAndroidContent {
    domain: DomainDto
    builder: INotificationBuilderState
    disabled?: boolean
    value?: NotificationNativeAndroidContentModel
    onChange: (content: NotificationNativeAndroidContentModel) => void
}

export const NotificationAndroidContent = (props: INotificationAndroidContent) => {
    const { disabled, value, onChange, builder } = props

    const [tmpVal, setTmpVal] = React.useState<NotificationNativeAndroidContentModel>(
        NotificationNativeAndroidContentModel.build(value ?? {}),
    )

    const channelOptions = builder.channelDependencies[DeliveryChannel.NATIVE_ANDROID].notificationChannels ?? []
    const workingModel = tmpVal.clone()

    return (
        <div className={getClassNames('native-ios-content')}>
            <Form.Item className="native-android-channel" label="Channel">
                {channelOptions.length ? (
                    <Select<number>
                        value={workingModel?.getChannelId() || channelOptions.find((channel) => channel.is_default)?.id}
                        disabled={disabled}
                        size="middle"
                        onChange={(v) => {
                            const update = workingModel?.clone()
                            update?.setChannelId(v)

                            setTmpVal(update)
                            onChange(update)
                        }}
                    >
                        {channelOptions.map((channel) => (
                            <Select.Option key={channel.id} value={channel.id}>
                                {channel.name}
                            </Select.Option>
                        ))}
                    </Select>
                ) : (
                    <>
                        <Alert
                            type="info"
                            showIcon={true}
                            message="Contact your account manager for more information on how to enable Android Notification Channels."
                        />
                    </>
                )}
            </Form.Item>
        </div>
    )
}
